import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_COMPONENT, REMOVE_ALL_COMPONENTS, REMOVE_COMPONENT, COMPONENTS_LOADED } from './components-actions.js'

export const componentsReducer = entriesReducerFactory(
  SET_COMPONENT,
  REMOVE_ALL_COMPONENTS,
  REMOVE_COMPONENT,
  COMPONENTS_LOADED,
)
